import styled from 'astroturf'
import React from 'react';

import { Link } from 'gatsby';

import RidipaperLogo from '../svgs/ridipaper.inline.svg';

import { LinkButton } from './Button';

const Container = /*#__PURE__*/styled("header", null, {
  displayName: "Container",
  styles: require("./header-Container.module.css"),
  attrs: null,
  vars: []
});

const FixedHeader = /*#__PURE__*/styled("div", null, {
  displayName: "FixedHeader",
  styles: require("./header-FixedHeader.module.css"),
  attrs: null,
  vars: []
});

const FixedHeaderInner = /*#__PURE__*/styled("div", null, {
  displayName: "FixedHeaderInner",
  styles: require("./header-FixedHeaderInner.module.css"),
  attrs: null,
  vars: []
});

const Center = /*#__PURE__*/styled("div", null, {
  displayName: "Center",
  styles: require("./header-Center.module.css"),
  attrs: null,
  vars: []
});

const Top = /*#__PURE__*/styled("div", null, {
  displayName: "Top",
  styles: require("./header-Top.module.css"),
  attrs: null,
  vars: []
});

const Bottom = /*#__PURE__*/styled("nav", null, {
  displayName: "Bottom",
  styles: require("./header-Bottom.module.css"),
  attrs: null,
  vars: []
});

const styles = require('./header-styles.module.css');

export default function Header() {
  const headerRef = React.useRef<HTMLElement>(null);
  const [showFixedHeader, setShowFixedHeader] = React.useState(false);
  React.useEffect(() => {
    if (window.IntersectionObserver == null) {
      // Fallback: use scroll event
      function checkScroll() {
        setShowFixedHeader(window.scrollY >= headerRef.current!.clientHeight);
      }

      checkScroll();
      window.addEventListener('scroll', checkScroll);
      return () => {
        window.removeEventListener('scroll', checkScroll);
      };
    }

    const io = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.target === headerRef.current) {
            setShowFixedHeader(entry.intersectionRatio <= 0);
          }
        });
      },
      {
        threshold: [0, 0.05],
      },
    );
    io.observe(headerRef.current!);
  }, []);

  return (
    <>
      <Container ref={headerRef}>
        <Center>
          <Top>
            <Link to="/" className={styles.logoLink}>
              <RidipaperLogo className={styles.ridipaperLogo} />
            </Link>
            <LinkButton
              to="/stockists/"
              size="small"
              color="white"
              className={styles.buy}
            >
              구매하기
            </LinkButton>
          </Top>
          <Bottom>
            <Link
              to="/ridipaper"
              className={styles.navButton}
              activeClassName={styles.active}
            >
              RIDIPAPER
            </Link>
            <Link
              to="/accessories/"
              className={styles.navButton}
              activeClassName={styles.active}
              partiallyActive
            >
              Accessory
            </Link>
          </Bottom>
        </Center>
      </Container>
      {showFixedHeader && (
        <FixedHeader>
          <FixedHeaderInner>
            <Link to="/" className={styles.logoLink}>
              <RidipaperLogo className={styles.ridipaperLogoDark} />
            </Link>
            <LinkButton
              to="/stockists/"
              size="small"
              color="gray"
              className={styles.buy}
            >
              구매하기
            </LinkButton>
          </FixedHeaderInner>
        </FixedHeader>
      )}
    </>
  );
}
